import styled, { css } from 'styled-components';
import { Text } from '@morressier/ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledInput = styled.input`
  padding: 8px;
  border: none;
  font-size: var(--fontSizes-normal);
  border-radius: 4px;
  line-height: var(--lineHeights-normal);
  width: 100%;
  &::placeholder,
  &:disabled {
    color: var(--color-mono-60);
  }
  &:focus {
    outline: none;
  }
`;

export const Container = styled.div<{ hasError: boolean; disabled?: boolean }>`
  display:flex;
  align-items: center;
  border: 1px solid ${({ hasError }) =>
    hasError ? 'var(--color-red-50)' : 'var(--color-mono-60)'};
  border-radius: 4px;
  width: 100%;
  svg {
    color: var(--color-mono-60);
  }
  &:hover, &:focus-within {
    border 1px solid ${({ hasError }) =>
      hasError ? 'var(--color-red-50)' : 'var(--color-mono-0)'};
    svg {
      color: var(--color-mono-0);
    }
  }
  &:focus-within{
    outline: var(--focus-style);
    outline-offset: 2px;
  }
  background-color: var(--color-mono-100);
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: var(--color-mono-95);
      border: 1px solid var(--color-mono-60);
    `}
`;

export const IconContainer = styled.span<{ position: 'start' | 'end' }>`
  padding: 8px;
  ${({ position }) =>
    position === 'start' &&
    css`
      padding-right: 0;
    `}
  ${({ position }) =>
    position === 'end' &&
    css`
      padding-left: 0;
    `}
`;

export const HelperText = styled.div`
  margin-top: 8px;
  display: flex;
`;

export const Limit = styled.span<{ isLimitExceeded: boolean }>`
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  color: ${({ isLimitExceeded }) =>
    isLimitExceeded ? 'var(--color-red-50)' : 'var(--color-mono-60)'};
  margin-left: auto;
`;

export const ErrorText = styled(Text).attrs({
  size: 'body1_new',
  textAs: 'span'
})`
  display: inline;
  color: var(--color-red-50);
`;

export const ErrorIcon = styled(FontAwesomeIcon)`
  font-size: var(--fontSizes-normal);
  color: var(--color-red-50);
`;
